const firebaseConfig = {
    apiKey: "AIzaSyCgF6uJDVirvo93OoCS4DVMIXUETDOQ448",
    authDomain: "pocketbook-ml.firebaseapp.com",
    databaseURL: "https://pocketbook-ml.firebaseio.com",
    projectId: "pocketbook-ml",
    storageBucket: "pocketbook-ml.appspot.com",
    messagingSenderId: "301352112701",
    appId: "1:301352112701:web:8ded0bd5bd8e597451d054",
    measurementId: "G-1PKNTG0WC6"
};

module.exports = {
    firebaseConfig
}
